import React from "react";

const LocationSection = () => {
  return (
    <section className=" bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] w-full py-16 sm:py-20 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 flex flex-col md:flex-row items-start md:items-center gap-10 lg:gap-16">
        
        {/* 📄 Left: Text Content */}
        <div className="md:w-1/2 space-y-6">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0077cc]">
            Our Location
          </h2>

          <p className="text-white/90 leading-relaxed text-base sm:text-lg">
            Whether you're interested in our AI solutions, medical coding services, 
            or have questions about our products, we'd love to hear from you.
          </p>

          <div>
            <p className="font-semibold text-lg sm:text-xl mb-2 text-[#0077cc]">
              Company Information
            </p>
            <address className="not-italic text-white/90 leading-relaxed text-base sm:text-lg">
              Wissenstil Solutions Private Ltd.<br />
              Brigade IRV Centre, 09th & 10th Floor,<br />
              Nallurahalli, Whitefield,<br />
              Bangalore, 560066
            </address>
          </div>
        </div>

        {/* 🗺️ Right: Map */}
        <div className="md:w-1/2 w-full h-[300px] sm:h-[350px] md:h-[400px] lg:h-[450px] rounded-xl overflow-hidden shadow-lg border border-white/30">
          <iframe
            title="Wissenstil Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.587097865086!2d77.71967311534193!3d12.97275719085618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15d49e54b3a7%3A0x4cbd8c8f0a7e59d2!2sBrigade%20IRV%20Centre!5e0!3m2!1sen!2sin!4v1688497599212!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
